import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth0 } from '@ondeck/silkworm';
import { Alert } from 'react-bootstrap';
import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import PartnerSupport from '../components/PartnerSupport';
import { useAppData } from 'contexts/appContext';
import Support from '../assets/support.png';
import { useTracking } from 'react-tracking';

type LoginFormInputs = {
  emailAddress: string;
  password: string;
};

const LoginPage = () => {
  const { updateAlert } = useAppData();
  const [redirectUrl, setRedirectUrl] = useState(false);
  const { register, handleSubmit } = useForm();
  const { login, callbackResponse } = useAuth0();
  const { search } = useLocation();
  const { trackEvent } = useTracking();
  const onSubmit = (data: LoginFormInputs) => {
    const { emailAddress, password } = data;
    login(emailAddress, password);
    setRedirectUrl(true);
    trackEvent({ event: 'Login', email: emailAddress });
  };
  const history = useHistory();
  const url = `${history.location.state?.from.pathname || '/'}`;
  if (redirectUrl && url.includes('/application/')) {
    sessionStorage.setItem('url', url);
  } else {
    sessionStorage.setItem('url', '/');
  }
  useEffect(() => {
    if (callbackResponse.code) {
      updateAlert(`login.alert.danger.${callbackResponse.code}`)
    } else if(callbackResponse.description) {
      updateAlert({variant:"danger", message: callbackResponse.description})
    }
  }, [callbackResponse]);

  useEffect(() => {
    if (search.includes('message')) {
      const message = search.split('message=')[1];
      switch (message) {
        case "timeout":
          return updateAlert(`login.alert.info.timeout`)
        case "sign-out":
          return updateAlert(`login.alert.success.sign-out`)
      }
    }
  }, [search]);

  return (
      <Card>
        <Card.Body>
          <Row>
            <Col xs={12} md={8}>
              <h1 className="fw-400">
                <FormattedMessage id="login.signIn" />
              </h1>
              <Form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-4">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    data-testid="email"
                    autoFocus
                    {...register('emailAddress', { required: true })}
                    type="email"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    data-testid="password"
                    {...register('password', { required: true })}
                    type="password"
                  />
                </Form.Group>
                <Button className="me-4" variant="primary" type="submit" data-testid="Button">
                  <FormattedMessage id="login.signIn" />
                </Button>
                <a href="/forgot-password" className="text-decoration-none">
                  <FormattedMessage id="login.forgotPass" />
                </a>
              </Form>
            </Col>
            <Col md={4} className="text-center">
              <PartnerSupport/>
            </Col>
          </Row>
        </Card.Body>
      </Card>
  );
};

export default LoginPage;
